import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import api from '@/services/api'

export const useAuthStore = defineStore('auth', () => {
  const user = ref(null)
  const loading = ref(false)
  const mustResetPassword = ref(false)

  const isAuthenticated = computed(() => !!user.value)

  async function fetchCurrentUser() {
    try {
      const response = await api.get('/auth/me')
      user.value = response.data.data
      mustResetPassword.value = user.value?.must_reset_password ?? false
    } catch {
      user.value = null
      mustResetPassword.value = false
    }
  }

  async function login(email, password) {
    loading.value = true
    try {
      const response = await api.post('/auth/login', { email, password })
      const data = response.data.data ?? response.data
      user.value = data.user
      mustResetPassword.value = data.must_reset_password ?? false
      return { mustResetPassword: mustResetPassword.value }
    } finally {
      loading.value = false
    }
  }

  async function logout() {
    try {
      await api.post('/auth/logout')
    } catch {
      // session may already be expired
    } finally {
      user.value = null
      mustResetPassword.value = false
      // Sin esto, el proyecto activo del usuario anterior sobrevive al logout:
      // el siguiente login arranca con X-Project-Id ajeno hasta que se recalcula.
      localStorage.removeItem('dorilon.activeProjectId')
    }
  }

  async function requestPasswordReset(email) {
    await api.post('/auth/password-reset-request', { email })
  }

  async function confirmPasswordReset(token, newPassword) {
    await api.post('/auth/password-reset-confirm', {
      token,
      new_password: newPassword,
    })
  }

  return {
    user,
    loading,
    mustResetPassword,
    isAuthenticated,
    fetchCurrentUser,
    login,
    logout,
    requestPasswordReset,
    confirmPasswordReset,
  }
})
